import React from 'react';
import './EventCard.css';
import { format, parseISO } from 'date-fns';
import logComponent from '../../common/logComponent';

export default function EventCard({ event }) {
  if (logComponent('EventCard')) { console.debug('EventCard rendered'); }

  return (
    <div className="Event-Card">
      <p className="Event-Card__heading">{ event.name }</p>
      <p className="Event-Card__description">{ event.description }</p>
      <ul className="Event-Card__detail-list">
        <li key="date" className="Event-Card__detail-item">
          <p>Date:</p>
          <p>{format(parseISO(event.localStartOn), 'MMMM dd, yyyy') }</p>
        </li>
        <li key="time" className="Event-Card__detail-item">
          <p>Time:</p>
          <p>{format(parseISO(event.localStartOn), 'h:mm aaa') }</p>
        </li>
        <li key="location" className="Event-Card__detail-item">
          <p>Location:</p>
          <p>{ event.location }</p>
        </li>
        <li key="remaining" className="Event-Card__detail-item">
          <p>Spaces remaining:</p>
          {/* TODO: Check what 'Capacity' will be set to in event that capacity is not limited */}
          <p>{ event.remainingSpaces }</p>
        </li>
      </ul>
      <div className="Event-Card__user-registration">

      </div>
    </div>
  );
}